import { useTranslation } from '@/lib/i18n.ts';
import Text from '@/components/ui/text/Text.tsx';
import { SealWarning } from '@/svg';
import { Button } from '@expanzi/ui-library';
import dayjs from 'dayjs';

type Props = {
    validUntil?: string | null;
    token?: string | null;
};

export default function LicenseBanner(props: Props) {
    const { validUntil, token } = props;
    const { t } = useTranslation();

    const licenseRemainingDays = validUntil ? Math.ceil(dayjs(validUntil).diff(dayjs(), 'hour') / 24) : -1;

    if (licenseRemainingDays > 30) {
        return;
    }

    return (
        <div className="bg-warning-light flex flex-col  items-center justify-between gap-3.5 px-3 py-5 sm:flex-row md:px-12">
            <div className="flex items-center gap-3 text-center">
                <SealWarning className="hidden size-8 sm:block" />
                <Text.H5>{validUntil ? t('licenseBanner.soonExpire') : t('licenseBanner.expired')}</Text.H5>
            </div>
            <Button href={`${import.meta.env.PUBLIC_OFFICE_URL}/public/eshop?token=${token}`} rounded>
                {t('licenseBanner.goOffice')}
            </Button>
        </div>
    );
}
